import type { ReactNode } from "react";
import {
    SimpleDialog,
    type SimpleDialogProps,
} from "../SimpleDialog/SimpleDialog";
import "./BottomDrawer.scss";

export interface BottomDrawerProps extends Omit<
    SimpleDialogProps,
    "children" | "content" | "header"
> {
    content: ReactNode;
}

export function BottomDrawer({
    content,
    className,
    ...dialogProps
}: BottomDrawerProps) {
    return (
        <SimpleDialog
            {...dialogProps}
            className={["bottom-drawer", className].filter(Boolean).join(" ")}
        >
            {content}
        </SimpleDialog>
    );
}
